/**
 * Les Parisiennes — Carousel Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 27. PRODUCT IMAGE REVEAL OBSERVER
   * ============================================================ */
  /* ============================================================
   * 27c. PRODUCT CAROUSEL
   * ============================================================ */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.carousel-track');
      var outer = wrap.querySelector('.carousel-track-outer');
      /* Collect ALL prev/next buttons (new carousel-nav + legacy) */
      var allPrev = wrap.querySelectorAll('.carousel-btn--prev');
      var allNext = wrap.querySelectorAll('.carousel-btn--next');
      if (!track || !outer) return;
      if (wrap.__lpCarouselRefresh) {
        wrap.__lpCarouselRefresh();
        return;
      }

      var currentIndex = 0;

      function getVisibleCols() {
        var w = window.innerWidth;
        var outerW = outer ? outer.offsetWidth : w;
        var gap = parseInt(getComputedStyle(track).gap || '4', 10);
        var attrCols = parseInt(wrap.dataset.cols || '4', 10);
        /* When a static feature card sits beside the track at desktop sizes
           the track only holds a portion of the row. Below 960px the CSS
           stacks feature above the carousel, so the feature stops competing
           for horizontal space and we can use the regular column count. */
        var hasStaticFeature = wrap.dataset.featureStatic === 'true';
        var featureActive = hasStaticFeature && w > 960;
        var baseCols = attrCols;
        if (w <= 480) baseCols = 2;
        else if (w <= 768) baseCols = Math.min(attrCols, 2);
        else if (w <= 1080) {
          var mid = Math.min(attrCols, 4);
          baseCols = featureActive ? Math.max(2, mid - 1) : mid;
        } else {
          baseCols = featureActive ? Math.max(2, attrCols - 1) : attrCols;
        }
        var minCardWidth = w <= 480 ? 136 : (w <= 768 ? 156 : 188);
        var fittedCols = Math.max(1, Math.floor((outerW + gap) / (minCardWidth + gap)));
        if (w <= 1080) {
          return Math.max(1, Math.min(baseCols, fittedCols));
        }
        return Math.max(1, Math.min(baseCols, fittedCols));
      }

      function getSlidesCount() {
        return track.querySelectorAll('.carousel-slide').length;
      }

      function getSlideWidth() {
        var slides = track.querySelectorAll('.carousel-slide');
        if (!slides.length) return 0;
        var outerW = outer.offsetWidth;
        var cols = getVisibleCols();
        var gap = parseInt(getComputedStyle(track).gap || '4', 10);
        return (outerW - gap * (cols - 1)) / cols;
      }

      function setSlideWidths() {
        var w = getSlideWidth();
        track.querySelectorAll('.carousel-slide').forEach(function (s) {
          s.style.width = w + 'px';
        });
      }

      function canScroll() {
        return getSlidesCount() > getVisibleCols();
      }

      function updateButtons() {
        if (!canScroll()) {
          allPrev.forEach(function (b) { b.style.visibility = 'hidden'; });
          allNext.forEach(function (b) { b.style.visibility = 'hidden'; });
          var mobileNav = wrap.querySelector('.carousel-nav-mobile');
          if (mobileNav) mobileNav.style.display = 'none';
          return;
        }
        var maxIdx = getSlidesCount() - getVisibleCols();
        allPrev.forEach(function (b) { b.style.visibility = currentIndex > 0 ? 'visible' : 'hidden'; });
        allNext.forEach(function (b) { b.style.visibility = currentIndex < maxIdx ? 'visible' : 'hidden'; });
      }

      function goTo(idx) {
        var maxIdx = Math.max(0, getSlidesCount() - getVisibleCols());
        currentIndex = Math.max(0, Math.min(idx, maxIdx));
        var gap = parseInt(getComputedStyle(track).gap || '4', 10);
        var w = getSlideWidth();
        track.style.transform = 'translateX(-' + (currentIndex * (w + gap)) + 'px)';
        updateButtons();
        /* reveal newly visible cards */
        var cols = getVisibleCols();
        track.querySelectorAll('.carousel-slide').forEach(function (s, i) {
          if (i >= currentIndex && i < currentIndex + cols) {
            var card = s.querySelector('.product-card');
            if (card && !card.classList.contains('is-revealed')) {
              setTimeout(function () { card.classList.add('is-revealed'); }, (i - currentIndex) * 80);
            }
          }
        });
      }

      function setup() {
        setSlideWidths();
        /* clamp currentIndex after resize */
        goTo(currentIndex);
      }

      allPrev.forEach(function (b) { b.addEventListener('click', function () { goTo(currentIndex - 1); }); });
      allNext.forEach(function (b) { b.addEventListener('click', function () { goTo(currentIndex + 1); }); });

      /* ── Pagination dots (fixed layout — no rebuild) ── */
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'carousel-dots';
      var navEl = wrap.querySelector('.carousel-nav');
      if (navEl) {
        var nextBtn = navEl.querySelector('.carousel-btn--next');
        if (nextBtn) navEl.insertBefore(dotsWrap, nextBtn);
        else navEl.appendChild(dotsWrap);
      }
      var dotEls = [];

      function buildDots() {
        var total = Math.max(0, getSlidesCount() - getVisibleCols()) + 1;
        dotsWrap.innerHTML = '';
        dotEls = [];
        if (total <= 1) { dotsWrap.style.display = 'none'; return; }
        dotsWrap.style.display = 'flex';
        for (var d = 0; d < total; d++) {
          var dot = document.createElement('span');
          dot.className = 'carousel-dot';
          dot.dataset.dot = d;
          dot.addEventListener('click', (function(idx) { return function() { goTo(idx); }; })(d));
          dotsWrap.appendChild(dot);
          dotEls.push(dot);
        }
        highlightDot();
      }

      function highlightDot() {
        dotEls.forEach(function(dot, i) {
          dot.classList.toggle('carousel-dot--active', i === currentIndex);
        });
      }

      /* Patch goTo to also update dot highlight */
      var _origGoTo = goTo;
      goTo = function (idx) { _origGoTo(idx); highlightDot(); };

      /* Touch/swipe with drag feedback */
      var touchStartX = 0, touchStartY = 0, touchDeltaX = 0, isSwiping = false, startTranslate = 0;
      outer.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isSwiping = false;
        var m = (track.style.transform || '').match(/translateX\((.+?)px\)/);
        startTranslate = m ? parseFloat(m[1]) : 0;
        track.style.transition = 'none';
      }, { passive: true });
      outer.addEventListener('touchmove', function (e) {
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;
        if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) isSwiping = true;
        if (!isSwiping) return;
        touchDeltaX = dx;
        /* Dampen at edges */
        var maxIdx = Math.max(0, getSlidesCount() - getVisibleCols());
        if ((currentIndex === 0 && dx > 0) || (currentIndex >= maxIdx && dx < 0)) dx *= 0.3;
        track.style.transform = 'translateX(' + (startTranslate + dx) + 'px)';
      }, { passive: true });
      outer.addEventListener('touchend', function (e) {
        track.style.transition = '';
        if (isSwiping && Math.abs(touchDeltaX) > 40) {
          goTo(currentIndex + (touchDeltaX < 0 ? 1 : -1));
        } else {
          goTo(currentIndex); /* snap back */
        }
        isSwiping = false;
      }, { passive: true });

      /* Desktop mouse drag — same model as touch for swipe parity */
      var mouseDown = false;
      outer.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mouseDown = true;
        touchStartX = e.clientX;
        touchStartY = e.clientY;
        touchDeltaX = 0;
        isSwiping = false;
        var m = (track.style.transform || '').match(/translateX\((.+?)px\)/);
        startTranslate = m ? parseFloat(m[1]) : 0;
        track.style.transition = 'none';
        outer.style.cursor = 'grabbing';
      });
      window.addEventListener('mousemove', function (e) {
        if (!mouseDown) return;
        var dx = e.clientX - touchStartX;
        var dy = e.clientY - touchStartY;
        if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) isSwiping = true;
        if (!isSwiping) return;
        e.preventDefault();
        touchDeltaX = dx;
        var maxIdx = Math.max(0, getSlidesCount() - getVisibleCols());
        if ((currentIndex === 0 && dx > 0) || (currentIndex >= maxIdx && dx < 0)) dx *= 0.3;
        track.style.transform = 'translateX(' + (startTranslate + dx) + 'px)';
      });
      window.addEventListener('mouseup', function (e) {
        if (!mouseDown) return;
        mouseDown = false;
        outer.style.cursor = '';
        track.style.transition = '';
        if (isSwiping && Math.abs(touchDeltaX) > 40) {
          goTo(currentIndex + (touchDeltaX < 0 ? 1 : -1));
          /* Suppress click on the slide that just got dragged so we don't navigate to a product */
          var suppress = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          outer.addEventListener('click', suppress, { capture: true, once: true });
        } else if (isSwiping) {
          goTo(currentIndex);
        }
        isSwiping = false;
      });
      outer.style.cursor = 'grab';

      buildDots();
      setup();
      wrap.__lpCarouselRefresh = function () {
        currentIndex = Math.min(currentIndex, Math.max(0, getSlidesCount() - getVisibleCols()));
        buildDots();
        setup();
      };
      var ro = window.ResizeObserver ? new ResizeObserver(function() { buildDots(); setup(); }) : null;
      if (ro) ro.observe(outer); else window.addEventListener('resize', setup);
    });
  }

  registerInit('initCarousels', initCarousels);
}());
